<style lang="less">
.index {
  width: 100%;
  min-width: 1080px;
  min-height: 100%;
  .head {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    min-width: 1080px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #2e384a;
    box-sizing: border-box;
    padding-left: 20px;
    z-index: 999;
    .organ-logo {
      position: absolute;
      left: 15px;
      height: 54px;
    }
    .headLeft {
      font-size: 0.16px;
      color: #6b6f6f;
      width: auto;
      padding: 0px 20px;
      box-sizing: border-box;
      margin-left: 40px;
      .foundation {
        height: 58px;
        line-height: 58px;
        text-align: center;
        cursor: pointer;
        font-size: 28px;
      }
    }
    .headRight {
      height: 58px;
      display: flex;
      .paddingdf {
        height: 100%;
        padding: 0px 20px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #fff;
      }
      .paddingdf:hover {
        background-color: #242c3a;
        cursor: pointer;
      }
      .headname {
        margin-left: 10px;
      }
      .figure {
        width: 14px;
        height: 14px;
      }
      .green {
        color: #007f57;
      }
    }
  }
  .aside {
    width: 240px;
    height: 100%;
    overflow-y: auto;
    background-color: #425069;
    position: fixed;
    left: 0;
    top: 0;
    box-sizing: border-box;
    padding-top: 58px;
    z-index: 998;
  }
  .main {
    width: 100%;
    box-sizing: border-box;
    padding-left: 240px;
    padding-top: 58px;
    background: #f3f3f3;
    height: 100vh;
  }
}
</style>
<template>
  <div class="index">
    <!-- 头部 -->
    <div class="head">
      <img :src="logo" class="organ-logo" >
      <div class="headLeft">
        <div class="foundation">{{ name }}</div>
      </div>
      <div class="headRight">
        <!-- <div class="paddingdf">
          <span class="el-icon-search green"></span>
          <span class="headname">搜索用户</span>
        </div>
        <div class="paddingdf">
          <span class="el-icon-question green"></span>
          <span class="headname">帮助文档</span>
        </div>-->
        <div class="paddingdf">
          <Dropdown>
            <img :src="userImg" class="figure" >
            <span class="headname">分析员</span>
            <DropdownMenu slot="list">
              <DropdownItem
                v-for="(menu, index) in userMenus"
                :key="index"
                :name="menu.name"
                :divided="menu.hasDivided"
              >
                <Button type="text" @click="GoUserMange(menu.pathName)">{{
                  menu.title
                }}</Button>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
    <!-- 左侧栏 -->
    <div class="aside noselect">
      <Menu
        theme="primary"
        ref="menus"
        :active-name="selectedMenu"
        :open-names="openMenu"
        @updateOpened="UpdateOpened"
        @updateActiveName="UpdateActiveName"
        accordion
      >
        <Submenu
          v-for="(menu, menu_index) in menus"
          :key="menu_index"
          :name="menu.name"
        >
          <template slot="title">
            <Icon :type="menu.icon"/>
            {{ menu.title }}
          </template>
          <menu-item
            v-for="(sub_menu, sub_menu_index) in menu.submenu"
            :key="sub_menu_index"
            :name="sub_menu.name"
            :to="{
              path: sub_menu.path,
              name: sub_menu.rName,
              params: {
                menuId: sub_menu.id,
                menuName: sub_menu.title
              }
            }"
            ><Icon :type="sub_menu.icon"/>{{ sub_menu.title }}</menu-item
          >
        </Submenu>
      </Menu>
    </div>
    <!-- 内容页 -->
    <div class="main">
      <router-view />
    </div>
    <Modal
      v-model="changePsword"
      title="修改密码"
      width="400"
      @on-ok="ChangePsword"
      @on-cancel="ResetPsword"
    >
      <p>原密码</p>
      <p>
        <i-input type="text" v-model="pswordData.oldPassword"/>
      </p>
      <p>新密码</p>
      <p>
        <i-input type="password" v-model="pswordData.newPassword"/>
      </p>
      <p>确认密码</p>
      <p>
        <i-input type="password" v-model="pswordData.confirmPassword"/>
      </p>
    </Modal>
  </div>
</template>

<script>
import userImg from '@assets/figure.png'
import adminApi from '@/lib/api/admin'
import analysisApi from '@lib/api/analysis'
export default {
  data() {
    return {
      name: '',
      logo: '',
      menus: [
        {
          name: 'dataAnalysis',
          title: '数据统计',
          icon: 'ios-people',
          id: '0',
          submenu: [
            {
              name: 'orgData',
              title: '机构数据',
              icon: '',
              id: 'org',
              rName: 'org',
              path: '/home/analysis/org'
            },
            {
              name: 'homeworkData',
              title: '作业数据',
              icon: '',
              id: 'homework',
              rName: 'homework',
              path: '/home/analysis/homework'
            },
            {
              name: 'studentData',
              title: '学生数据',
              icon: '',
              id: 'studentData',
              rName: 'studentData',
              path: '/home/analysis/student'
            },
            {
              name: 'teacherData',
              title: '老师数据',
              icon: '',
              id: 'teacherData',
              rName: 'teacherData',
              path: '/home/analysis/teacher'
            },
            {
              name: 'activityData',
              title: '活动数据',
              icon: '',
              id: 'activityData',
              rName: 'activityData',
              path: '/home/analysis/activity'
            }
          ]
        },
        {
          name: 'schoolManage',
          title: '校区管理',
          icon: 'logo-usd',
          id: '1',
          submenu: [
            {
              name: 'teacherManage',
              title: '教师管理',
              icon: '',
              id: 'teacher',
              rName: 'teacher',
              path: '/home/school/teacher'
            },
            {
              name: 'manager',
              title: '管理员管理',
              icon: '',
              id: 'manager',
              rName: 'manager',
              path: '/home/school/manager'
            },
            {
              name: 'classManage',
              title: '班级管理',
              icon: '',
              id: 'class',
              rName: 'class',
              path: '/home/school/class'
            },
            {
              name: 'studentManage',
              title: '学生管理',
              icon: '',
              id: 'student',
              rName: 'student',
              path: '/home/school/student'
            },
            {
              name: 'studentApplyManage',
              title: '学生申请管理',
              icon: '',
              id: 'studentApply',
              rName: 'studentApply',
              path: '/home/school/studentApply'
            },
            {
              name: 'studentAccountManage',
              title: '学生账号有效数',
              icon: '',
              id: 'studentAccount',
              rName: 'studentAccount',
              path: '/home/school/studentAccount'
            }
            // {
            //   name: "experienceClass",
            //   title: "体验班管理",
            //   icon: "",
            //   id: "experienceClass",
            //   rName: "experienceClass",
            //   path: "/home/school/experienceClass"
            // }
          ]
        },
        {
          name: 'brandManage',
          title: '品牌管理',
          icon: 'ios-stats',
          id: '2',
          submenu: [
            {
              name: 'orgInfo',
              title: '机构信息',
              icon: '',
              id: 'orgInfo',
              rName: 'orgInfo',
              path: '/home/brand/info'
            },
            {
              name: 'orgBanner',
              title: '机构品牌',
              icon: '',
              id: 'orgBanner',
              rName: 'orgBanner',
              path: '/home/brand/banner'
            }
          ]
        }
        // 「测评管理」为动态菜单，由 can_use_evaluation 控制，见 GetOrganInfo
        // {
        //   name: 'testDemo',
        //   title: '测试',
        //   icon: 'md-tablet-portrait',
        //   id: '3',
        //   submenu: [
        //     {
        //       name: 'videoDemo',
        //       title: '调用拍照测试',
        //       icon: '',
        //       id: 'videoDemo',
        //       rName: 'videoDemo',
        //       path: '/home/test/videoDemo'
        //     },
        //   ]
        // },
        // {
        //   name: 'contentManage',
        //   title: '内容管理',
        //   icon: 'ios-radio',
        //   id: '4',
        //   submenu: [
        //     {
        //       name: 'itemUpload',
        //       title: '素材上传',
        //       icon: '',
        //       id: 'itemUpload',
        //       rName: 'itemUpload',
        //       path: '/home/content/item'
        //     }
        //   ]
        // },
        // {
        //   name: 'rateManage',
        //   title: '权限管理',
        //   icon: 'ios-contact',
        //   id: '5',
        //   submenu: [
        //     {
        //       name: 'adminManage',
        //       title: '权限管理',
        //       icon: '',
        //       id: 'adminManage',
        //       rName: 'adminManage',
        //       path: '/home/admin/index'
        //     }
        //   ]
        // }
      ],
      selectedMenu: 'orgData',
      openMenu: ['dataAnalysis'],
      userImg: userImg,
      userMenus: [
        {
          name: 'manage',
          title: '权限管理',
          pathName: 'manage'
        },
        {
          name: 'changePsword',
          title: '修改密码',
          pathName: 'changePsword'
        },
        {
          name: 'logout',
          title: '注销',
          pathName: 'logout',
          hasDivided: true
        }
      ],
      changePsword: false,
      pswordData: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  methods: {
    GetQueryString(name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      const r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    // 获取机构信息
    GetOrganInfo() {
      analysisApi.GetOrgan().then(res => {
        console.log('机构信息', res)
        this.name = res.data.name
        this.logo = res.data.logo
        // can_use_evaluation === 1 时动态挂载「测评管理」菜单，字段缺失或为 0 则不显示
        if (Number(res.data.can_use_evaluation) === 1) {
          this.AddEvaluationMenu()
        }
      })
    },
    // 动态追加「测评管理」菜单（避免重复追加）
    AddEvaluationMenu() {
      if (this.menus.some(m => m.name === 'evaluationManage')) return
      this.menus.push({
        name: 'evaluationManage',
        title: '测评管理',
        icon: 'ios-clipboard',
        id: '6',
        submenu: [
          {
            name: 'evaluationList',
            title: '试卷管理',
            icon: '',
            id: 'evaluationList',
            rName: 'evaluationList',
            path: '/home/evaluation/list'
          }
        ]
      })
    },
    GetNewMenus() {
      this.menus = [
        {
          name: 'dataAnalysis',
          title: '数据统计',
          icon: 'ios-people',
          id: '0',
          submenu: [
            {
              name: 'orgData',
              title: '机构数据',
              icon: '',
              id: 'org',
              rName: 'org',
              path: '/home/analysis/org'
            },
            {
              name: 'homeworkData',
              title: '作业数据',
              icon: '',
              id: 'homework',
              rName: 'homework',
              path: '/home/analysis/homework'
            },
            {
              name: 'studentData',
              title: '学生数据',
              icon: '',
              id: 'studentData',
              rName: 'studentData',
              path: '/home/analysis/student'
            },
            {
              name: 'teacherData',
              title: '老师数据',
              icon: '',
              id: 'teacherData',
              rName: 'teacherData',
              path: '/home/analysis/teacher'
            },
            {
              name: 'activityData',
              title: '活动数据',
              icon: '',
              id: 'activityData',
              rName: 'activityData',
              path: '/home/analysis/activity'
            }
          ]
        },
        {
          name: 'schoolManage',
          title: '校区管理',
          icon: 'logo-usd',
          id: '1',
          submenu: [
            {
              name: 'teacherManage',
              title: '教师管理',
              icon: '',
              id: 'teacher',
              rName: 'teacher',
              path: '/home/school/teacher'
            },
            {
              name: 'manager',
              title: '管理员管理',
              icon: '',
              id: 'manager',
              rName: 'manager',
              path: '/home/school/manager'
            },
            {
              name: 'classManage',
              title: '班级管理',
              icon: '',
              id: 'class',
              rName: 'class',
              path: '/home/school/class'
            },
            {
              name: 'studentManage',
              title: '学生管理',
              icon: '',
              id: 'student',
              rName: 'student',
              path: '/home/school/student'
            },
            {
              name: 'studentApplyManage',
              title: '学生申请管理',
              icon: '',
              id: 'studentApply',
              rName: 'studentApply',
              path: '/home/school/studentApply'
            }
          ]
        },
        {
          name: 'brandManage',
          title: '品牌管理',
          icon: 'ios-stats',
          id: '2',
          submenu: [
            {
              name: 'orgInfo',
              title: '机构信息',
              icon: '',
              id: 'orgInfo',
              rName: 'orgInfo',
              path: '/home/brand/info'
            },
            {
              name: 'orgBanner',
              title: '机构品牌',
              icon: '',
              id: 'orgBanner',
              rName: 'orgBanner',
              path: '/home/brand/banner'
            }
          ]
        },
        {
          name: 'testDemo',
          title: '测试',
          icon: 'md-tablet-portrait',
          id: '3',
          submenu: [
            {
              name: 'videoDemo',
              title: '调用拍照测试',
              icon: '',
              id: 'videoDemo',
              rName: 'videoDemo',
              path: '/home/test/videoDemo'
            }
          ]
        }
      ]
    },
    Check() {
      const that = this
      analysisApi
        .GetLogin({
          token: that.GetQueryString('token')
        })
        .then(res => {
          console.log(res)
        })
    },
    UpdateOpened(name) {
      this.openMenu = name
    },
    UpdateActiveName(name) {
      this.$nextTick(() => {
        this.selectedMenu = name
      })
    },
    GoUserMange(pathName) {
      if (pathName === 'logout') {
        this.$store.dispatch('signOut')
        this.$router.push('/')
      } else if (pathName === 'changePsword') {
        this.changePsword = true
      } else {
        this.$router.push({ name: pathName })
      }
    },
    ChangePsword() {
      adminApi
        .ChangeWord({
          oldWord: this.pswordData.oldPassword,
          newWord: this.pswordData.newPassword
        })
        .then(res => {
          if (res.status == 1) {
            this.$Message.info('修改成功')
          } else {
            alert(res.msg)
          }
        })
    },
    ResetPsword() {
      this.pswordData = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    InitSelectIndexMenu() {
      const firstMenu = this.menus[0].submenu[0]
      // this.selectedMenu = firstMenu.name;
      this.openMenu = [this.menus[0].name]
      this.$nextTick(() => {
        this.$refs.menus.updateOpened()
        this.selectedMenu = firstMenu.name
        this.$nextTick(() => {
          this.$refs.menus.updateActiveName()
        })
      })
      this.$router.push({
        path: firstMenu.path,
        name: firstMenu.rName,
        params: {
          menuId: firstMenu.id,
          menuName: firstMenu.title
        },
        query: {
          menuName: firstMenu.title,
          timestamp: new Date().getTime()
        }
      })
    }
  },
  created() {},
  mounted() {
    this.GetOrganInfo()
    // this.$router.push('/home/analysis/org')
  },
  beforeRouteUpdate(to, from, next) {
    this.menus.forEach(menu => {
      const pName = menu.name
      menu.submenu.forEach(sub_menu => {
        // if (to.params.menuId === sub_menu.id) {
        //   this.selectedMenu = sub_menu.id;
        //   this.openMenu[0] = pName;
        // }
        if (to.params.menuId === sub_menu.id) {
          this.openMenu[0] = pName
          this.$nextTick(() => {
            this.$refs.menus.updateOpened()
            this.selectedMenu = sub_menu.name
            this.$nextTick(() => {
              this.$refs.menus.updateActiveName()
            })
          })
        }
      })
    })
    next()
  }
}
</script>
